const Actions = self => ({
  openSaveToCrmPopup: setter => {
    const { showPopup, selectedIntegration, ...rest } = setter;
    const { contact } = setter;

    // save the integration name to localStorage, to open the save popup with this integration
    if (selectedIntegration) {
      localStorage.setItem('lastIntegrationSaved', JSON.stringify({ name: selectedIntegration }));
    }

    self.isSaveToCrmPopupIsOpen = true;
    self.saveToCrmPopupOptions = { contact, ...rest };
  },
  closeSaveToCrmPopup: () => {
    self.isSaveToCrmPopupIsOpen = false;
    self.saveToCrmPopupOptions = {};
  },
});

export default Actions;
